exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-width:768px){.mobile-breadcumbs[data-v-d7bafa66]{font-size:15px;height:21px;font-weight:500;color:#000;display:flex;align-items:center;margin-right:auto;width:30%}.breadcrumbs-txt[data-v-d7bafa66]{width:90%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d7bafa66","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/layouts/MobileBreadcrumbsResults.vue
// module id = 531
// module chunks = 187